import axios from "axios";
import { API_ENDPOINTS } from "../Utils/ApiEndPoints";
import axiosInstance from "../Utils/axiosInstance";
import * as XLSX from "xlsx";

class HomeService{
    static async getDashboardData(type){
        try{
          
            const url = API_ENDPOINTS.getDashboardCount(type);
            const token = localStorage.getItem('token');
            const response = await axiosInstance.get(url,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
          });
          const result = response.data;
          if(result.result.length > 0){
            return { success: true,data:result };
          }else {
            return { success: false, data: result };
          }
        }
        catch(error){
            console.error("Error Occured:",error)
        }
    }
    static async getDashboardDetailsData(type){
        try{
            const url = API_ENDPOINTS.getDashboardReportDetails(type);
            const token = localStorage.getItem('token');
            const response = await axiosInstance.get(url,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
          });
          const result = response.data;
          if(result.result.length > 0){
            
            return { success: true,data:result };
          }else {
            
            return { success: false, data: result };
          }
        }
        catch(error){
            console.error("Error Occured:",error)
        }
    }
    static async getPrintPreview(lcnumber){
      try{
        
          const url = API_ENDPOINTS.getPrintPreview(lcnumber);
          const token = localStorage.getItem('token');
          const response = await axiosInstance.get(url,{
          headers:{
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
        });
        const result = response.data;
        if(result.result.length > 0){
          
          return { success: true,data:result };
        }else {
          
          return { success: false, data: result };
        }
      }
      catch(error){
          console.error("Error Occured:",error)
      }
  }
    static async CreateApprovalAction(formData) {
        try {
          const url = API_ENDPOINTS.InsertApproverAction();
          const token = localStorage.getItem('token');
          const response = await axios.post(url, formData, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
          });
          
          const resultndData = response.data;
          if(resultndData.result> 0){
            
            return { success: true,data:resultndData };
          }else {
            
            return { success: false, data: resultndData };
          }
        } catch (error) {
          if (error.response && error.response.data) {
            
            const errorData = error.response.data;
      
            
            const errorMessage = errorData.message || "Unknown error from server";
      
            console.error("API error message:", errorMessage);
      
            return { success: false, errorMessage };
          } else {
            
            console.error("Error creating ticket:", error.message || error);
            return { success: false, errorMessage: error.message || "Unknown error" };
          }
        }
      }

      static async getApproverHistory(id){
        try{
          
            const url = API_ENDPOINTS.getApproverHistory(id);
            const token = localStorage.getItem('token');
            const response = await axiosInstance.get(url,{
            headers:{
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
          });
          const result = response.data;
          if(result.result.length > 0){
            
            return { success: true,data:result };
          }else {
            
            return { success: false, data: result };
          }
        }
        catch(error){
            console.error("Error Occured:",error)
        }
    }

    static async getstatusReport(lcNumber,statusId,pageNumber,pageSize,subjectTitle,
      lcApproval,requestedBy){
      try{
        
          const url = API_ENDPOINTS.getstatusReport(lcNumber,statusId,pageNumber,pageSize,
            subjectTitle,lcApproval,requestedBy);
          const token = localStorage.getItem('token');
          const response = await axiosInstance.get(url,{
          headers:{
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
        });
        const result = response.data;
        if(result.result.length > 0){
          
          return { success: true,data:result };
        }else {
          
          return { success: false, data: result };
        }
      }
      catch(error){
          console.error("Error Occured:",error)
      }
  }

  static async gettatReport(lcNumber,fromdate,todate,pageNumber,pageSize){
    try{
      
        const url = API_ENDPOINTS.gettatReport(lcNumber,fromdate,todate,pageNumber,pageSize);
        const token = localStorage.getItem('token');
        const response = await axiosInstance.get(url,{
        headers:{
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if(result.result.length > 0){
        
        return { success: true,data:result };
      }else {
        
        return { success: false, data: result };
      }
    }
    catch(error){
        console.error("Error Occured:",error)
    }
}
    static async downloadLcAttachment(fileName) {
      try {
        const url  =API_ENDPOINTS.DowanloadAttachment(fileName);
          const token = localStorage.getItem("token");
          const response = await axiosInstance.get(url, {
              headers: {
                  "Authorization": `Bearer ${token}`
              },
              responseType: "blob", // Important for file download
          });
          
          // Create download
          const href = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', fileName); // Optional: set file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      } catch (error) {
          console.error("Error downloading file:", error);
      }
  }
 

static async previewAttachment(fileName, onPreviewExcel) {
  try {
    
    const url = API_ENDPOINTS.PreviewAttachment(encodeURIComponent(fileName));
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(url, {
      headers: {
        "Authorization": `Bearer ${token}`
      },
      responseType: "blob",
    });
     
    const fileExtension = fileName.split('.').pop().toLowerCase();
    const mimeTypeMap = {
      pdf: "application/pdf",
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      gif: "image/gif",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };

    const blob = new Blob([response.data], { type: mimeTypeMap[fileExtension] || "application/octet-stream" });
    const fileURL = URL.createObjectURL(blob);

    if (["pdf", "png", "jpg", "jpeg", "gif"].includes(fileExtension)) {
      
      onPreviewExcel([], fileName, fileURL);
    } else if (["xls", "xlsx"].includes(fileExtension)) {
      // Read blob as array buffer and parse with SheetJS
      const arrayBuffer = await blob.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      
      const allSheetsData = workbook.SheetNames.map(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        return {
          sheetName,
          data: jsonData,
        };
      });

      // Pass parsed data to React component via callback
      onPreviewExcel(allSheetsData, fileName, fileURL);  // 👈 This callback will open modal
    } else {
      // Default download for other files
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

  } catch (error) {
    console.error("Error previewing/downloading file:", error);
  }
}

static async actionpreviewAttachment(fileName, onPreviewExcel,type) {
  try {
    
    const url = API_ENDPOINTS.ActionPreviewAttachment(encodeURIComponent(fileName),type);
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(url, {
      headers: {
        "Authorization": `Bearer ${token}`
      },
      responseType: "blob",
    });

    const fileExtension = fileName.split('.').pop().toLowerCase();
    const mimeTypeMap = {
      pdf: "application/pdf",
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      gif: "image/gif",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };

    const blob = new Blob([response.data], { type: mimeTypeMap[fileExtension] || "application/octet-stream" });
    const fileURL = URL.createObjectURL(blob);

    if (["pdf", "png", "jpg", "jpeg", "gif"].includes(fileExtension)) {
      
      onPreviewExcel([], fileName, fileURL);
    } else if (["xls", "xlsx"].includes(fileExtension)) {
      // Read blob as array buffer and parse with SheetJS
      const arrayBuffer = await blob.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      
      const allSheetsData = workbook.SheetNames.map(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        return {
          sheetName,
          data: jsonData,
        };
      });

      // Pass parsed data to React component via callback
      onPreviewExcel(allSheetsData, fileName, fileURL);  // 👈 This callback will open modal
    } else {
      // Default download for other files
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

  } catch (error) {
    console.error("Error previewing/downloading file:", error);
  }
}

static async getWarningMessage(){
  try{
    
      const url = API_ENDPOINTS.getWarning();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url,{
      headers:{
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      },
    });
    const result = response.data;
    if(result.result.length > 0){
      
      return { success: true,data:result };
    }else {
      
      return { success: false, data: result };
    }
  }
  catch(error){
      console.error("Error Occured:",error)
  }
}

static async getSmartReport(payload) {
  try {
    debugger
    const url = API_ENDPOINTS.getSmartReport();
    const token = localStorage.getItem('token');

    const response = await axiosInstance.post(url, payload, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    });

    const result = response.data;
    if (result.result && result.result.length > 0) {
      return { success: true, data: result.result };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    console.error("Error Occurred:", error);
    return { success: false, error };
  }
}

  
  
    
    
}   
    
export default HomeService